import React, { useState, useEffect } from 'react';
import { WindowLocation } from '@reach/router';

import {
  ContentfulCombinatorSection,
  ContentfulConditionalSection,
  ContentfulForm,
  ContentfulPhone,
  MobilistTipData,
} from '../../../ContentfulTypes';
import PhoneConditionalBanner from '../../screens/PhoneScreen/PhoneConditionalBanner/PhoneConditionalBanner';
import { ImageLoadingType } from '../../UI/Image/Image';

import { PhoneList } from './styles';
import ProductsView from './ProductsView/ProductsView';

interface Props {
  products: Array<ContentfulPhone>;
  province?: string;
  isMsaActive: boolean;
  location: WindowLocation<unknown>;
  mobilistTipsData: Array<MobilistTipData>;
  standardNoResults: ContentfulCombinatorSection;
  phoneLabelData: ContentfulForm;
  conditionalMultiBannerBottom?: ContentfulConditionalSection;
  phoneHeading: string;
  tabletHeading: string;
  prepaidPhonesHeading: string;
}

const Products = ({
  products,
  province = '',
  isMsaActive,
  location,
  mobilistTipsData,
  standardNoResults,
  phoneLabelData,
  conditionalMultiBannerBottom,
  phoneHeading,
  tabletHeading,
  prepaidPhonesHeading,
}: Props) => {
  const [isLoading, setIsLoading] = useState(true);

  // Scroll to phones section with query string (trade-in)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (location?.search?.includes('trade-in')) {
        document?.getElementById('phonesDefault')?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      }
    }
  }, [location]);

  return (
    <PhoneList>
      {/* Default target for product container smooth scroll */}
      <div id="phonesDefault">
        &nbsp;
      </div>
      <ProductsView
        isLoading={isLoading}
        standardNoResults={standardNoResults}
        mobilistTipsData={mobilistTipsData}
        isMsaActive={isMsaActive}
        prepaidPhonesHeading={prepaidPhonesHeading}
        tabletHeading={tabletHeading}
        phoneHeading={phoneHeading}
        products={products}
        province={province}
        phoneLabelData={phoneLabelData}
        location={location}
        setIsLoading={setIsLoading}
      />
      {/* Conditional Banner Bottom */}
      {conditionalMultiBannerBottom && !isLoading && (
        <PhoneConditionalBanner
          conditionalMultiBanner={conditionalMultiBannerBottom}
          useSharpImage
          imageLoadingType={ImageLoadingType.Lazy}
        />
      )}
    </PhoneList>
  );
};

export default Products;
